import AxiosWrapper from "../common/AxiosWrapper";
import {AxiosError, AxiosResponse, AxiosRequestConfig} from "axios";

export interface QueryParam {
    name: string;
    value: any;
}

class RepositoryWorker {
    static makeGetCallInternal<TResponse>(url: string, params?: QueryParam[], config?: AxiosRequestConfig): Promise<TResponse> {
        const pp: any = {};
        if (params) {
            params
                .filter(q => q.value !== null && q.value !== undefined)
                .map(q => pp[q.name] = q.value);
        }

        return this.createPromise(AxiosWrapper.get(url, {...config, params: {...config?.params, ...pp}}));
    }

    static makePostCallInternal<TResponse>(url: string, data: any, config?: AxiosRequestConfig): Promise<TResponse> {
        return this.createPromise(config ? AxiosWrapper.post(url, data, config) : AxiosWrapper.post(url, data));
    }

    static makePutCallInternal<TResponse>(url: string, data: any, config?: AxiosRequestConfig): Promise<TResponse> {
        return this.createPromise(config ? AxiosWrapper.put(url, data, config) : AxiosWrapper.put(url, data));
    }

    static makeDeleteCallInternal<TResponse>(url: string, config?: AxiosRequestConfig): Promise<TResponse> {
        return this.createPromise(config ? AxiosWrapper.delete(url, config) : AxiosWrapper.delete(url));
    }

    private static createPromise(promise: Promise<AxiosResponse<any>>): Promise<any> {
        return new Promise(
            (resolve: any, reject: any) => {
                this.processFlow(promise, resolve, reject);
            }
        );
    }

    private static processFlow(promise: Promise<AxiosResponse<any>>, resolve: any, reject: any) {
        promise
            .then((response: AxiosResponse<any>) => {
                if (response.status < 200 || response.status >= 300) {
                    reject(response.data);
                    return;
                }
                resolve(response.status === 204 ? undefined : response.data);
            })
            .catch((e: AxiosError) => {
                reject(e.response || e);
            });
    }
}

export default RepositoryWorker;
